import styled from 'styled-components';

interface Props {
  isAboveStickyCTA: boolean;
  toastOffset: number;
}

const CTA_HEIGHT = 121;

/**
 * Calculates total offset from bottom edge of screen based on
 * other sticky overlay items present such, i.e. toasts or sticky cta
 * 
 * @param props
 * @param gap (pixels) offset from any other sticky overlay items
 * @param bottomEdgeGap (pixels) offset when no other sticky overlay items are present 
 * @returns 
 */
const calculateOffset = (props: Props, gap: number, bottomEdgeGap: number) => {
  if (!props.isAboveStickyCTA && !props.toastOffset) {
    return `${bottomEdgeGap.toString()}px`;
  }

  let offset = gap + props.toastOffset;
  if (props.isAboveStickyCTA) { offset += CTA_HEIGHT; }

  return `${offset.toString()}px`;
};

export const ButtonWrapper = styled.button<Props>`
  position: fixed;
  bottom: 24px;
  right: 24px;
  cursor: pointer;
  z-index: 999;
  background-color: white;
  color: white;
  border: 1px solid black;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;

  &:focus-visible {
    outline: none;
  }

  @media (hover: hover) {
    &:hover {
      background: #e0e0e0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      svg path {
        fill: #555555;
      }
    }
  }

  @media (max-width: 767px) {
    bottom: ${(props) => calculateOffset(props, 7, 24)};
  }
`;

export const Prompt = styled.div<Props>`
  position: fixed;
  bottom: 68px;
  right: 68px;
  z-index: 999;
  background: #F0F0F0;
  color: #000000;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  padding: 8px 12px;
  width: 210px;
  word-wrap: break-word;
  transition: all 0.4s ease;

  p {
    font-size: 14px;
    margin: 0;
  }

  @media (max-width: 767px) {
    bottom: ${(props) => calculateOffset(props, 51, 68)};
  }
`;
